<template>
  <div>
    <b-container>
      <div class="row justify-content-center">
        <div class="column w-75">
          <div class="col-12 mt-4 d-flex justify-content-between align-items-center">
            <back-arrow :title="user.firstname + ' ' + user.lastname"/>
          </div>

          <div class="row">
            <div class="col-12 col-md-8">
              <b-card class="mt-2 mb-2 shadow-sm main-grey-medium-color">
                {{ $t('profile.edit.non.editable.fields') }}
              </b-card>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <b-card class="mt-2 mb-4 shadow-sm">
                <b-form @submit.stop.prevent="clickOnValidateBtn">

                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-6">
                      <b-form-group
                        :invalid-feedback="form.phoneNumber.invalidFeedback"
                        :label="$t('user.PhoneNumber')"
                        :state="form.phoneNumber.state"
                        class="small-text"
                        label-for="phoneNumber-input">
                        <vue-phone-number-input
                          id="phone-input"
                          v-model="form.phoneNumber.value"
                          :dark="true"
                          :error="form.phoneNumber.error"
                          :default-country-code="form.phoneNumber.countryCode"
                          :placeholder="$t('user.phoneNumber')"
                          dark-color="#303030"
                          required
                          @update="checkPhone"/>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-6">
                      <b-form-group
                        :invalid-feedback="form.department.invalidFeedback"
                        :label="$t('user.Department')"
                        :state="form.department.state"
                        class="small-text mb-4"
                        label-for="department-input"
                      >
                        <b-form-select
                          id="department-input"
                          v-model="form.department.value"
                          :state="form.department.state">
                          <option v-for="department in departments" :value="department.serverId">
                            {{ department.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </div>

                    <div class="col-12 col-md-6 col-lg-6">
                      <b-form-group
                        :invalid-feedback="form.profession.invalidFeedback"
                        :label="$t('user.Profession')"
                        :state="form.profession.state"
                        class="small-text mb-4"
                        label-for="profession-input">
                        <b-form-select
                          id="profession-input"
                          v-model="form.profession.value"
                          :state="form.profession.state">
                          <option v-for="profession in professions" :value="profession.serverId">
                            {{ profession.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="row" v-if="$store.state.identityToSubmit">
                    <div class="col-6">
                      <b-form-group
                        :invalid-feedback="form.identityRecto.invalidFeedback"
                        :label="$t('profile.edit.identity.recto')"
                        :state="form.identityRecto.state"
                        class="small-text form-group-with-label-legend"
                        label-for="identityRecto-input">
                        <b-form-file
                          id="identityRecto-input"
                          style="z-index: 0 !important;"
                          ref="identityRecto-input"
                          v-model="form.identityRecto.value"
                          :browse-text="$t('Select')"
                          :drop-placeholder="$t('drop-placeholder')"
                          :placeholder="form.identityRecto.fileName"
                          accept=".png, .jpeg, .jpg, .pdf"
                          required
                          @change="event => previewImage(event, 'identityRecto')"
                        >
                        </b-form-file>
                        <PreviewOneFile
                          :file="form.identityRecto"
                          :imagePreviewSrc="imagePreviewIdentityRectoFile"
                          :pdfPreviewSrc="pdfPreviewIdentityRectoFile"
                          :showDelete="false"
                          fileId="identityRecto"
                        >
                        </PreviewOneFile>
                      </b-form-group>
                    </div>

                    <div class="col-6">
                      <b-form-group
                        :invalid-feedback="form.identityVerso.invalidFeedback"
                        :label="$t('profile.edit.identity.verso')"
                        :state="form.identityVerso.state"
                        class="small-text form-group-with-label-legend"
                        label-for="identityVerso-input">
                        <b-form-file
                          id="identityVerso-input"
                          style="z-index: 0 !important;"
                          ref="identityVerso-input"
                          v-model="form.identityVerso.value"
                          :browse-text="$t('Select')"
                          :drop-placeholder="$t('drop-placeholder')"
                          :placeholder="form.identityVerso.fileName"
                          accept=".png, .jpeg, .jpg, .pdf"
                          required
                          @change="event => previewImage(event, 'identityVerso')"
                        >
                        </b-form-file>
                        <PreviewOneFile
                          :file="form.identityVerso"
                          :imagePreviewSrc="imagePreviewIdentityVersoFile"
                          :pdfPreviewSrc="pdfPreviewIdentityVersoFile"
                          :showDelete="false"
                          fileId="identityVerso"
                        >
                        </PreviewOneFile>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <b-form-group
                        :invalid-feedback="form.rib.invalidFeedback"
                        :label="$t('profile.edit.rib')"
                        :state="form.rib.state"
                        class="small-text form-group-with-label-legend"
                        label-for="rib-input">
                        <b-form-file
                          id="rib-input"
                          style="z-index: 0 !important;"
                          ref="rib-input"
                          v-model="form.rib.value"
                          :browse-text="$t('Select')"
                          :drop-placeholder="$t('drop-placeholder')"
                          :placeholder="form.rib.fileName"
                          accept=".png, .jpeg, .jpg, .pdf"
                          @change="event => previewImage(event, 'rib')"
                        >
                        </b-form-file>
                        <PreviewOneFile
                          :file="form.rib"
                          :imagePreviewSrc="imagePreviewRibFile"
                          :pdfPreviewSrc="pdfPreviewRibFile"
                          :showDelete="true"
                          fileId="rib"
                          @deleteFileInPreview="deleteFileFromPreview('rib')">
                        </PreviewOneFile>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
                  </div>
                </b-form>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import i18n from '../../i18n'
import BackArrow from '../../components/b122/BackArrow.vue'
import PreviewOneFile from "../../components/b122/showFields/PreviewOneFile";

export default {

  name: 'ProfileEdit',
  components: {BackArrow, PreviewOneFile},

  data() {
    return {

      userId: this.$store.getters.userId,
      user: {},
      departments: [],
      professions: [],
      form: {
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        department: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        profession: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        identityRecto: {
          id: null,
          state: null,
          invalidFeedback: null,
          fileName: "",
          value: null
        },
        identityVerso: {
          id: null,
          state: null,
          invalidFeedback: null,
          fileName: "",
          value: null
        },
        rib: {
          id: null,
          state: null,
          invalidFeedback: null,
          fileName: "",
          value: null
        },
      },
      imagePreviewRibFile: null,
      pdfPreviewRibFile: null,
      imagePreviewIdentityRectoFile: null,
      pdfPreviewIdentityRectoFile: null,
      imagePreviewIdentityVersoFile: null,
      pdfPreviewIdentityVersoFile: null,

      _blobUrls: []
    }
  },

  mounted() {
    this.fetchData()
  },

  beforeDestroy() {
    this.cleanupBlobs()
  },

  methods: {

    async fetchData() {
      this.fetchUser()
      this.fetchDepartments()
      this.fetchProfessions()
    },

    fetchUser() {
      api
        .get(`/user/getProfile`)
        .then(async response => {
          this.user = response.data
          await this.setInitialValues()
        })
        .catch((error) => {
          // this.$router.push({
          //   name: '/',
          //   params: {
          //     message: error
          //   }
          // })
        })
    },

    fetchDepartments() {
      api
        .get(`/apiMobile/getAllDepartments`)
        .then(response => {
          this.departments = response.data
        })
    },

    fetchProfessions() {
      api
        .get(`/apiMobile/getAllProfessions`)
        .then(response => {
          this.professions = response.data
        })
    },

    pushBlobUrl(u) {
      if (!u) return u
      if (!this._blobUrls) this._blobUrls = []
      this._blobUrls.push(u)
      return u
    },

    cleanupBlobs() {
      if (this._blobUrls && this._blobUrls.length) {
        this._blobUrls.forEach(u => { try { window.URL.revokeObjectURL(u) } catch (e) {} })
      }
      this._blobUrls = []
    },

    isAlreadyResolvedUrl(u) {
      return typeof u === 'string' && (u.startsWith('blob:') || u.startsWith('data:') || u.startsWith('http://') || u.startsWith('https://'))
    },

    async loadProtectedFile(fileUrl) {
      try {
        const res = await api.get(fileUrl, { responseType: 'blob' })
        return this.pushBlobUrl(window.URL.createObjectURL(res.data))
      } catch (e) {
        return null
      }
    },

    async setInitialValues() {
      this.form.phoneNumber.value = this.user.phoneNumber
      this.form.phoneNumber.inputValue = this.user.phoneNumber
      this.form.phoneNumber.countryCode = this.$store.state.currentUserCountryCode
      this.form.department.value = this.user.department ? this.user.department.value : null
      this.form.profession.value = this.user.profession ? this.user.profession.value : null

      if (this.user.rib && this.user.rib.id) {
        this.form.rib.id = this.user.rib.id
        const candidateUrl = this.user.rib.url || this.user.rib.fileUrl
        if (candidateUrl) {
          if (this.isAlreadyResolvedUrl(candidateUrl)) {
            this.form.rib = {
              ...this.user.rib,
              url: candidateUrl
            }
          } else {
            const blobUrl = await this.loadProtectedFile(candidateUrl)
            this.form.rib = {
              ...this.user.rib,
              url: blobUrl || null
            }
          }
        } else {
          this.form.rib = {
            ...this.user.rib,
            url: null
          }
        }
      }
    },

    checkPhone(value) {
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.form.phoneNumber.countryCode = value.countryCode
      this.removeInvalidFeedback('phoneNumber')
    },

    previewImage(event, imageType) {
      // Référence au fichier
      const file = event.target.files[0]
      this.setPreviewImageFromFile(file, imageType, false)
    },

    setPreviewImageFromFile(file, imageType, isInit) {
      var isPdf = file.type === "application/pdf"

      // Utilisation de FileReader pour lire le contenu du fichier
      const reader = new FileReader()

      reader.onload = () => {

        //Le contenu du fichier lu
        var base64 = reader.result

        var pdfPreview = isPdf ? base64 : null
        var imagePreview = !isPdf ? base64 : null

        //Mise à jour de la prévisualisation de l'image avec le contenu du fichier lu
        if (imageType === "rib") {
          this.pdfPreviewRibFile = pdfPreview
          this.imagePreviewRibFile = imagePreview
          if (!isInit) {
            this.resetFileObject('rib', false)
          }
        }
        else if (imageType === "identityRecto") {
          this.pdfPreviewIdentityRectoFile = pdfPreview
          this.imagePreviewIdentityRectoFile = imagePreview
          if (!isInit) {
            this.resetFileObject('identityRecto', false)
          }
        }
        else if (imageType === "identityVerso") {
          this.pdfPreviewIdentityVersoFile = pdfPreview
          this.imagePreviewIdentityVersoFile = imagePreview
          if (!isInit) {
            this.resetFileObject('identityVerso', false)
          }
        }
      };

      // Lecture du contenu du fichier
      reader.readAsDataURL(file)
    },

    async deleteFileFromPreview(imageType) {
      if(imageType === "rib") {
        this.pdfPreviewRibFile = null
        this.imagePreviewRibFile = null
        this.resetFileObject('rib', true)
      }
    },

    resetFileObject(fileObjectName, resettingFileInput) {
      if (resettingFileInput) {
        this.form[fileObjectName].value = null
        this.form[fileObjectName].fileName = null
      }
      this.form[fileObjectName].state = null
      this.form[fileObjectName].invalidFeedback = null
      this.form[fileObjectName].id = null
      this.form[fileObjectName].url = null
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    clickOnValidateBtn() {
      this.onSubmit()
    },

    onSubmit() {
      let data = new FormData()
      data.append('phoneNumber', this.form.phoneNumber.inputValue)
      data.append('countryCode', this.form.phoneNumber.countryCode)
      if (this.form.department.value) {
        data.append('department', this.form.department.value)
      }
      if (this.form.profession.value) {
        data.append('profession', this.form.profession.value)
      }
      if (this.form.rib.value) {
        data.append('ribFile', this.form.rib.value)
        data.append('ribFileId', this.form.rib.id)
      }
      if (this.form.identityRecto.value) {
        data.append('identityRectoFile', this.form.identityRecto.value)
        data.append('identityRectoFileId', this.form.identityRecto.id)
      }
      if (this.form.identityVerso.value) {
        data.append('identityVersoFile', this.form.identityVerso.value)
        data.append('identityVersoFileId', this.form.identityVerso.id)
      }

      api({
        method: 'POST',
        url: `/user/updatePublicProfile`,
        data: data
      })
        .then((response) => {
          this.$store.state.identityToSubmit = response.data.identityToSubmit
          this.$store.state.currentUserCountryCode = this.form.phoneNumber.value.countryCode
          this.successToast()
          this.$nextTick(() => {
            this.$router.back()
          })
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && (error.response.status === 401 || error.response.status === 404)) {
            this.$router.push({
              name: '/',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    successToast () {
      this.$bvToast.toast(this.$i18n.t('profile.edit.toast'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        solid: true,
        variant: 'success',
        title: this.$i18n.t('Modification.saved')
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/ProfileEdit.vue